module.exports = __webpack_public_path__ + "media/chip2.4ce9ced7.mp3";